<script lang="ts">
    import Expander from "@/app/utils/expander.js";
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class Dropdown extends Vue {
        @Prop()
        data: any;
        @Prop()
        dark;
        @Prop()
        selfStyle;
        @Prop({
            default: -1,
        })
        activeId;
        @Prop({
            default: () => [],
        })
        activeList;

        dropdownRoot = null;
        showOption = false;

        expander: any;
        expandFunc(type: string, args?: any) {
            if (!this.expander) {
                let dom = this.dropdownRoot;
                let expand = () => {
                    this.showOption = !this.showOption;
                };
                let select = (args: any) => {
                    // 点击内容区冒泡触发隐藏窗口
                    let { index, item } = args;
                    this.showOption = false;
                    this.$emit("selectData", index);
                };
                let close = () => {
                    this.showOption = false;
                };
                this.expander = new Expander(dom, {
                    expand: expand,
                    select: select,
                    close: close,
                });
            }
            if (type == "expand") {
                this.expander.expand();
            } else if (type == "select") {
                this.expander.select(args);
            }
        }
        mounted() {
            this.dropdownRoot = this.$refs.dropdownRoot;
        }
    }
</script>

<template>
    <div ref="dropdownRoot" class="z-dropdown" :class="{ 'z-dropdown-dark': dark }">
        <div class="z-dropdown-titlebox" @click="expandFunc('expand')">
            <slot />
        </div>
        <div class="z-dropdown-selector" :style="selfStyle" v-show="showOption">
            <div
                :class="{
                    active: item.type !== 'checked' && item.id == activeId,
                    'z-dropdown-item': item.type != 'split',
                }"
                v-for="(item, index) in data"
                :key="index"
                @click="expandFunc('select', { index, item })"
            >
                <template v-if="item.type == 'split'">
                    <div class="z-dropdown-split"></div>
                </template>
                <template v-else>
                    <div class="z-dropdown-box">
                        <img class="z-dropdown-img" v-if="item.img" :src="item.img" alt="" />
                        <div class="z-dropdown-checked" v-if="item.type == 'checked'">
                            <img
                                v-if="item.id == activeId || activeList.includes(item.id)"
                                :src="require('@/home/assets/onlineview/dropdown_check.svg')"
                                alt=""
                            />
                        </div>
                        <p class="z-dropdown-itemtext" :title="item.label">{{ item.label }}</p>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
    .z-dropdown
        position relative
        user-select none

        .z-dropdown-titlebox
            display flex
            align-items center
            width 100%
        .z-dropdown-selector
            position absolute
            top 100%
            right 0
            min-width 80px
            padding 6px
            background var(--bg-color-tertiary)
            box-shadow $box-shadow
            border-radius 8px
            z-index 2
            .z-dropdown-split
                width 100%
                height 1px
                background var(--color-black-8)
                margin 4px 0
            .z-dropdown-item
                position relative
                display flex
                align-items center
                height 28px
                border-radius 6px
                &:hover
                    background var(--bg-color-dropdown-item-hover)

                &.active
                    background var(--bg-color-dropdown-item-active)
                .z-dropdown-box
                    display flex
                    align-items center
                    padding 0 14px
                    .z-dropdown-itemtext
                        width 100%
                        font-size 13px
                        color var(--text-color-primary)
                        max-width 120px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap

                    .z-dropdown-img
                        margin-right 4px
                    .z-dropdown-checked
                        flex-shrink 0
                        width 16px
                        height 16px
                        margin-right 8px
    .z-dropdown-dark
        .z-dropdown-selector
            background #2A2C2E
            .z-dropdown-item
                &:hover
                    background rgba(255, 255, 255, 0.08)

                &.active
                    background rgba(255, 255, 255, 0.06)
                .z-dropdown-box
                    .z-dropdown-itemtext
                        color #E6E6E6
</style>
